export default __webpack_public_path__ + "static/media/adi.aac27604.jpeg";